// extracted by mini-css-extract-plugin
export default {"Navbar":"nav_Navbar__vFHD6","hoverEffect":"nav_hoverEffect__VpklX","hamburger-menu":"nav_hamburger-menu__unYmy","open":"nav_open__7cLqy","closed":"nav_closed__LObWt"};